import React, { useEffect, useRef, useState } from 'react';

const InternalBanner: React.FC = () => {
  const [visible, setVisible] = useState(true);
  const bannerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const root = document.documentElement;

    const updateOffset = () => {
      if (!visible) {
        root.style.setProperty('--internal-banner-offset', '0px');
        return;
      }
      const height = bannerRef.current?.getBoundingClientRect().height || 0;
      root.style.setProperty('--internal-banner-offset', `${height}px`);
    };

    updateOffset();
    window.addEventListener('resize', updateOffset);
    return () => {
      window.removeEventListener('resize', updateOffset);
      root.style.setProperty('--internal-banner-offset', '0px');
    };
  }, [visible]);

  if (!visible) return null;

  return (
    <div
      ref={bannerRef}
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        width: '100%',
        backgroundColor: '#111827',
        color: '#FCA5A5',
        padding: '6px 12px',
        textAlign: 'center',
        fontSize: 12,
        borderBottom: '1px solid #7F1D1D',
        zIndex: 1400,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 8,
      }}
    >
      <span>Internal Only — Control Plane Actions Are Audited</span>
      <button
        onClick={() => setVisible(false)}
        aria-label="Dismiss internal banner"
        title="Dismiss"
        style={{
          marginLeft: 8,
          border: 'none',
          background: 'transparent',
          color: '#FCA5A5',
          cursor: 'pointer',
          fontSize: 14,
          lineHeight: 1,
        }}
      >
        ×
      </button>
    </div>
  );
};

export default InternalBanner;
